export default "__VITE_ASSET__rvh63t3S__"